import { EXCEPTION_HEADERS_LIST, ETab, HeaderActionType } from "../constants";

/**
 * Build dynamic API headers for OSD APIs.
 * @param tab - Current tab (ETab)
 * @param activeTerminal - Terminal object (should have terminalId)
 * @param exception - Exception object (should have osdNumber, origin, destination, reporting)
 * @param sectionName - OSD-Section-Name value (optional, default undefined)
 * @returns Headers object
 */
export function buildApiHeaders({
  tab,
  activeTerminal,
  exception,
  moduleName,
  sectionName,
  osdType,
  osdNumber,
}: {
  tab: ETab;
  activeTerminal?: { terminalId?: string };
  exception?: Partial<{
    osdNumber: number | string;
    origin: string;
    destination: string;
    reporting: string;
  }>;
  sectionName?: string;
  moduleName?: string;
  osdType?: string;
  osdNumber?: number | string;
}): Record<string, any> {
  const headers: Record<string, any> = {};
  const tabHeaders = EXCEPTION_HEADERS_LIST[tab as keyof typeof EXCEPTION_HEADERS_LIST];
  if (tabHeaders) {
    Object.assign(headers, tabHeaders);
  }
  if (sectionName) headers["OSD-Section-Name"] = sectionName;
  const terminalId = activeTerminal?.terminalId ?? "";
  if (terminalId) {
    if ([ETab.overages].includes(tab)) {
      headers["OSD-Reporting-Terminal"] = terminalId;
    } else if (![ETab.myAssignments, ETab.dashboard].includes(tab)) {
      headers["OSD-Destination-Terminal"] = terminalId;
    }
  }
  if (exception?.osdNumber) {
    headers["OSD-Origin-Terminal"] = exception.origin;
    headers["OSD-Destination-Terminal"] = exception.destination;
    headers["OSD-Reporting-Terminal"] = exception.reporting;
    headers["OSD-Exception-Number"] = exception.osdNumber.toString();
  }
  if (moduleName) headers["OSD-Module-Name"] = moduleName;
  if (osdType) headers["OSD-Exception-Type"] = osdType;
  if (osdNumber) headers["OSD-Exception-Number"] = osdNumber.toString();

  return headers;
}

export const trackingHeaders = ({
  osdNumber,
  osdType,
  sectionName,
  moduleName,
  origin,
  destination,
  reporting,
  pickup,
  actionType,
}: {
  osdNumber?: number | string;
  osdType?: string;
  sectionName?: string;
  moduleName?: string;
  origin?: string;
  destination?: string;
  reporting?: string;
  pickup?: string;
  actionType?: string;
}) => {
  return {
    "Content-Type": "application/json",
    "OSD-Module-Name": moduleName ?? "",
    "OSD-Section-Name": sectionName ?? "",
    "OSD-Action-Type": actionType ?? "",
    "OSD-Exception-Number": osdNumber?.toString() ?? "",
    "OSD-Reporting-Terminal": reporting ?? "",
    "OSD-Origin-Terminal": origin ?? "",
    "OSD-Destination-Terminal": destination ?? "",
    "OSD-Pickup-Terminal": pickup ?? "",
  };
};


export const getHeaderActionType = (action: string) => {
  return HeaderActionType[action as keyof typeof HeaderActionType] ?? action;
};